export default "__VITE_ASSET__0fe3f3de__"